import Immutable from 'immutable';

export const getImmutableField = (field) => (Immutable.Map.isMap(field) ? field : Immutable.Map(field));
